import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "catalog-products-controls" };
const _hoisted_2 = { class: "catalog-products-controls__sort" };
const _hoisted_3 = ["onClick"];
const _hoisted_4 = { class: "catalog-products-controls__view" };
const _hoisted_5 = { class: "button-group" };
const _hoisted_6 = ["onClick", "title"];
import { ref, computed, nextTick } from "vue";
import Icon from "@astina/paloma-common-ui/src/components/Icon.vue";
import AppDropdown from "@astina/paloma-common-ui/src/components/AppDropdown.vue";
// TODO sortable attributes
export default /*@__PURE__*/ _defineComponent({
    __name: 'CatalogProductsControls',
    props: {
        sort: {},
        sortDirection: {},
        mode: {}
    },
    emits: ['select-sort', 'select-mode'],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const props = __props;
        const sortDropdownOpen = ref();
        const selectedSortOption = computed(() => {
            if (!props.sort) {
                return undefined;
            }
            return sortOptions.find(opt => opt.sort === props.sort
                && (opt.order === props.sortDirection || props.sortDirection === undefined));
        });
        const selectedSortDirection = computed(() => {
            return selectedSortOption.value?.order;
        });
        const sortIcon = computed(() => {
            if (selectedSortDirection.value === 'asc') {
                return 'sort-asc';
            }
            else if (selectedSortDirection.value === 'desc') {
                return 'sort-desc';
            }
            return 'sort';
        });
        function selectSortOption(opt) {
            emit('select-sort', opt.sort, opt.order);
            sortDropdownOpen.value = false;
            // the dropdown reacts to change, so we need to reset this
            nextTick(() => sortDropdownOpen.value = undefined);
        }
        // basic sorting options
        const sortOptions = [
            {
                name: 'relevance',
                sort: 'relevance',
                order: 'desc',
            },
            {
                name: 'price_asc',
                sort: 'price',
                order: 'asc',
            },
            {
                name: 'price_desc',
                sort: 'price',
                order: 'desc',
            },
            // {
            //     name: 'base_unit_price_asc',
            //     sort: 'base_unit_price',
            //     order: 'asc',
            // },
            // {
            //     name: 'base_unit_price_desc',
            //     sort: 'base_unit_price',
            //     order: 'desc',
            // },
            {
                name: 'name_asc',
                sort: 'name',
                order: 'asc',
            },
            {
                name: 'name_desc',
                sort: 'name',
                order: 'desc',
            },
        ];
        const modes = ['grid', 'list'];
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(AppDropdown, {
                        "button-style": "link",
                        open: sortDropdownOpen.value,
                        position: "left"
                    }, {
                        button: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('catalog.sort')) + _toDisplayString(selectedSortOption.value ? ':' : '') + " " + _toDisplayString(selectedSortOption.value ? _ctx.$t('catalog.sort.' + selectedSortOption.value.sort) : '') + " ", 1),
                            _createVNode(Icon, {
                                name: sortIcon.value,
                                "icon-style": "duotone"
                            }, null, 8, ["name"])
                        ]),
                        menu: _withCtx(() => [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(sortOptions, (opt) => {
                                return _createElementVNode("a", {
                                    onClick: _withModifiers(($event) => (selectSortOption(opt)), ["prevent"]),
                                    key: opt.name,
                                    href: "#",
                                    class: _normalizeClass(["dropdown__item", { 'dropdown__item--active': selectedSortOption.value === opt }])
                                }, _toDisplayString(_ctx.$t('catalog.sort.' + opt.name)), 11, _hoisted_3);
                            }), 64))
                        ]),
                        _: 1
                    }, 8, ["open"])
                ]),
                _cache[1] || (_cache[1] = _createTextVNode()),
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(modes, (_mode) => {
                            return _createElementVNode("button", {
                                key: _mode,
                                class: _normalizeClass(["button button--outline button--icon button--small", { 'button--active': __props.mode === _mode }]),
                                onClick: ($event) => (_ctx.$emit('select-mode', _mode)),
                                title: _ctx.$t('catalog.products.view_' + _mode)
                            }, [
                                _createVNode(Icon, { name: _mode }, null, 8, ["name"])
                            ], 10, _hoisted_6);
                        }), 64))
                    ])
                ])
            ]));
        };
    }
});
